import { Logger } from '@precert/logger';
import React from 'react';
import { isIE } from 'react-device-detect';
import { QueryClient, QueryClientProvider } from 'react-query';
import 'react-day-picker/dist/style.css';

import { ConfigProvider } from '../_components/config';
// import { License } from '../pages/license/license';
import { Toastr } from '../_components/toastr';
import '../sass/style.scss';

import BrowserNotSupported from './browser-not-supported';
import ErrorBoundary from './error-boundary';
import { Routes } from './routes';
import { ThemeProvider } from './theme-provider';

const log = Logger('app:main');

// Create a client
const queryClient = new QueryClient();

export default function App() {
  log.info(`=======>>>>>>>>>> Entry point URL: ${globalThis.location.href}`);
  if (isIE) return <BrowserNotSupported />;

  const config = import.meta.env.VITE_LOCAL_CONFIG || '/config.json';
  log.info(`Using config ${config}`);
  return (
    <ConfigProvider config={config}>
      <ErrorBoundary
        onError={(err: any) => log.error('!!! APP ERROR !!!: ', err)}
      >
        <Toastr>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <Routes />
            </ThemeProvider>
          </QueryClientProvider>
        </Toastr>
      </ErrorBoundary>
    </ConfigProvider>
  );
}
